import {API_AUTH_URL, API_URL, API_PAYMENTS_URL} from '../constants/index';

import router from '../router';
import eventBus from '../event-bus';

export const fetchWithAuth = (url, options) => {
  const token = getCookie('token');
  const headers = {
    ...options.headers,
    'Authorization': `Bearer ${token}`
  };

  // Parse the URL to check if it already contains a sellerId parameter
  let parsedUrl;
  if (url.includes('://')) {
    parsedUrl = new URL(url);
  } else {
    parsedUrl = new URL(url, window.location.origin);
  }
  const hasSellerId = parsedUrl.searchParams.has('sellerId');

  // If sellerId is not already present in the URL, add it from the logged-in user's info
  if (!hasSellerId) {
    const sellerId = getLoggedSellerId();
    if (sellerId) {
      parsedUrl.searchParams.set('userId', sellerId);
    }
  }

  // Reconstruct the URL with any added query parameters
  const finalUrl = parsedUrl.toString();

  eventBus.$emit('show-loading');
  // Return the fetch call with updated headers and URL
  return fetch(finalUrl, { ...options, headers: headers, credentials: 'include'  })
    .finally(() => {
      // Emit event to hide loading screen after receiving the response
      eventBus.$emit('hide-loading');
    });
};

export const fetchWithAuthUserId = (url, options) => {
  const token = getCookie('token');
  const headers = {
    ...options.headers,
    'Authorization': `Bearer ${token}`
  };

  // Parse the URL to check if it already contains a sellerId parameter
  let parsedUrl;
  if (url.includes('://')) {
    parsedUrl = new URL(url);
  } else {
    parsedUrl = new URL(url, window.location.origin);
  }

  const userId = getCookie('userId');
  parsedUrl.searchParams.set('userId', userId);

  // Reconstruct the URL with any added query parameters
  const finalUrl = parsedUrl.toString();

  eventBus.$emit('show-loading');
  // Return the fetch call with updated headers and URL
  return fetch(finalUrl, { ...options, headers: headers, credentials: 'include'  })
    .finally(() => {
      // Emit event to hide loading screen after receiving the response
      eventBus.$emit('hide-loading');
    });
};

// define a response interceptor that checks for 401 errors
export const responseInterceptor = (response) => {
  if (response?.status === 401) {
    // Check if the response has a 'text' method
    if ('text' in response) {
      const clonedResponse = response.clone();
      clonedResponse.text().then((body) => {
        if (body.trim() === 'unauthorized') {
          // Redirect to the unauthorized page
          router.push('/unauthorized');
        }
      }).catch((error) => {
        console.error('Error reading response body:', error);
      });
    } else {
      console.warn('Response does not have a text() method.');
    }
  }
  if (response?.status === 406) {
    let role = getCookie('role')
    if (role === 'OPS' || role === 'SUPERADMIN') {
      router.push('/tncErrorPopup');
    }
  }
  return response;
};

// intercept all fetch responses with the responseInterceptor function
fetch = (function(originalFetch) {
  return function() {
    return originalFetch.apply(this, arguments)
      .then(responseInterceptor);
  };
})(fetch);

export function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      if (name === 'token' || name === 'sellerId' || name === 'role' || 
        name === 'tncAcceptance' || name === 'userId' || name === 'ipAddress' || 
        name === 'twoFactorRegistered' || name === 'userEmail') {
        let value = cookie.substring(`${name}=`.length);
        return value;
      }
    }
  }
  return null;
};

// expireTime= 2023-05-24T19:11:01.231+00:00
export function setCookie(name, value, expireTime) {
  let expires = '';
  if (expireTime) {
    const date = new Date(expireTime);
    expires = '; expires=' + date.toUTCString();
  }
  let cookieValue = '';
  if (name === 'token' || name === 'sellerId' || name === 'role' ||
    name === 'tncAcceptance' || name === 'userId' || name === 'ipAddress' || 
    name === 'twoFactorRegistered' || name === 'userEmail') {
    cookieValue = value;
  }
  document.cookie = name + '=' + cookieValue + expires + '; path=/';
};

export function clearCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export function getLoggedSellerId() {
  if (!!getCookie('token')) {
    return getCookie('sellerId')
  }
}

export function getTncAcceptance() {
  if (!!getCookie('token')) {
    return getCookie('tncAcceptance')
  }
}

export function getQueryParam(param) {
  const params = new URLSearchParams(new URL(window.location.href).search);
  return params.get(param);
}

//Campaigns APIs

export async function createCampaign(campaign, queryParams) {

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
    body: JSON.stringify(campaign),
  };

  return await fetchWithAuth(`${API_URL}/jiomartads/v1/campaign/create?action=${queryParams}`, requestOptions)
}

export async function modifyCampaign(campaign, queryParams) {

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(campaign)
  };

  return await fetchWithAuth(`${API_URL}/jiomartads/v1/campaign/modify?action=${queryParams}`, requestOptions)
}

export async function getCampaign(campaignId, jmId) {
  if(campaignId){
    jmId = null;
  }
  let params = {
    channel_id: 4,
    jmcampaign_id: jmId,
    id: campaignId,
  }

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  };

  return await fetchWithAuth(`${API_URL}/jiomartads/v1/campaign/view`,requestOptions)
}

export async function getCampaignList(params) {
  let str = '';
  for(const [key,value] of Object.entries(params)){
    if(value)
      str = str+key+"="+value+"&";
  }
  str = str.slice(0, -1); 

  return await fetchWithAuth(`${API_URL}/jiomartads/v1/campaign/loadHomePage?`+str, {
      method: 'GET',
      params: params
    })
}

export async function getKeywordSuggestions(params) {
  console.log(params, 'params')
  return await fetchWithAuth(`${API_URL}/jiomartads/v1/adgroup/keyword/suggest`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(params),
 })

}

export async function deleteCampaign(campaignId) {
  return await fetchWithAuth(`${API_URL}/jiomartads/v1/campaigns/delete?campaignId=`+campaignId, {
      method: 'DELETE',
    })
}

export async function getAdgroupsList(params) {
  return await fetchWithAuth(`${API_URL}/jiomartads/v1/adgroup/list`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(params),
    })
}

export async function adgroupView(adGroupId) {
  
  let params = {
    channel_id: 4,
    id: adGroupId,
  }

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  };

  return await fetchWithAuth(`${API_URL}/jiomartads/v1/adgroup/view`,requestOptions)
}

export async function createAdgroup(params, queryParams) {

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  };

  return await fetchWithAuth(`${API_URL}/jiomartads/v1/adgroup/create?action=${queryParams}`,requestOptions)
}

export async function modifyAdgroup(params, queryParams){
  
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  }
   
  return await fetchWithAuth(`${API_URL}/jiomartads/v1/adgroup/modify?action=${queryParams}`, requestOptions)
}

export async function downloadCampaignHomePageMetrics(queryParams) {
  const url = `${API_URL}/jiomartads/v1/campaign/download?${queryParams}`;

  const options = {
    method: "GET",
  };

  const response = await fetchWithAuth(url, options);

  if (!response.ok) {
    throw new Error(`Failed to download file. Status: ${response.status}`);
  }

  // Extract the filename from the response headers
  const filename = `CampaignHomePage.csv`;

  // Create a blob URL for the file
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);

  // Create a link with the URL and simulate a click to download the file
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  link.click();
}

//Analytics APIs 

export async function getDefaultReport() {
  return await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/getDefaultReport`, {
    method: 'GET',
  })
}

export async function getFilters() {
  return await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/getFilters`, {
    method: 'GET',
  })
}

export async function generateReport(params) {

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  };

  return await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/generateReport`, requestOptions)
}

export async function getSavedReports() {
  return await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/getSavedReports`, {
    method: 'GET',
  })
}

export async function getDefaultReports(payload, otp) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  };
  return  await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/getOpsReport?otp=${otp}`, requestOptions);
}

export async function getReport(page, size) {
  return await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/getReport?page=${page}&size=${size}`, {
    method: 'GET',
  })
}

export async function downloadReport(reportEntityId, otp) {
 
  return await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/downloadReport?reportEntityId=${reportEntityId}&otp=${otp}`, {
    method: 'GET',
  })
}

export async function generateOtp() {
 
  return await fetchWithAuth(`${API_AUTH_URL}/v1/generate-otp`, {
    method: 'POST',
  })
}

export async function deleteReport(reportEntityId) {
  return await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/deleteReport?reportEntityId=${reportEntityId}`, {
    method: 'DELETE',
  })
}

export async function saveAndScheduleReport(params) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
    body: JSON.stringify(params),
  };
  return await fetchWithAuth(`${API_URL}/jiomartads/adinventory/v1/analytics/saveAndScheduleReport`, requestOptions)
}

export async function termsAndConditions(params) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
    body: JSON.stringify(params),
  };
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/tnc`, requestOptions)
}

//Billing APIs

export async function uploadCreditDetails(formData) {
  const requestOptions = {
    method: 'POST',
    body: formData,
  };

  return await fetchWithAuthUserId(`${API_PAYMENTS_URL}/payment/post-paid/input-credit-csv`, requestOptions)
}

export async function uploadPromotionalCredit(formData) {
  const requestOptions = {
    method: 'POST',
    body: formData,
  };

  return await fetchWithAuthUserId(`${API_PAYMENTS_URL}/payment/post-paid/input-Promo-credit`, requestOptions)
}


export async function uploadRechargeDetails(formData) {
  const requestOptions = {
    method: 'POST',
    body: formData,
  };
  return await fetchWithAuthUserId(`${API_PAYMENTS_URL}/payment/post-paid/input-amount-paid`, requestOptions)
}

export async function downloadCreditReport() {
  const url =`${API_PAYMENTS_URL}/payment/test/generate_credit_report`;

  const options = {
    method: "GET",
  };

  const response = await fetchWithAuthUserId(url, options);

  if (!response.ok) {
    throw new Error(`Failed to download file. Status: ${response.status}`);
  }

  // Extract the filename from the response headers
  const filename = `CreditLimit.csv`;

  // Create a blob URL for the file
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);

  // Create a link with the URL and simulate a click to download the file
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  link.click();
}

export async function downloadPromotionalCreditReport() {
  const url =`${API_PAYMENTS_URL}/payment/test/generate_promo_report`;

  const options = {
    method: "GET",
  };

  const response = await fetchWithAuthUserId(url, options);

  if (!response.ok) {
    throw new Error(`Failed to download file. Status: ${response.status}`);
  }

  // Extract the filename from the response headers
  const filename = `PromoCredits.csv`;

  // Create a blob URL for the file
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);

  // Create a link with the URL and simulate a click to download the file
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  link.click();
}

export async function checkAvailableCredit(queryParams) {
  const requestOptions = {
    method: 'GET',
  };

  return await fetchWithAuth(`${API_PAYMENTS_URL}/payment/post-paid/check-available-credit`, requestOptions)
}

export async function validateSellerIdAndToken() {
  let token = getCookie('token');
  let ipAddress = getCookie('ipAddress');
  const requestOptions = {
    method: 'GET',
  };

  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/validateToken?token=${token}&ipAddress=${ipAddress}`, requestOptions)
}

export async function getPincodeData(pincode) {
 
  return await fetchWithAuth(`${API_URL}/v1/pincodes/fetch?pincodes=${pincode}`, {
    method: 'GET',
  })
}

export async function onboardUsers(payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
    body: JSON.stringify(payload),
  };
  return await fetchWithAuthUserId(`${API_AUTH_URL}/v1/onBoardUsers`, requestOptions)
}

export async function getQRTwoFactorAuth(params) {
  const { email, token, userId, ipAddress } = params;
 
  return await fetch(`${API_AUTH_URL}/v1/gauth2fa-signup?email=${email}&token=${token}&userId=${userId}&ipAddress=${ipAddress}`, {
    method: 'GET',
  })
}

export async function twoFaVerifyOtp(payload, params) {
  const { token, userId, ipAddress } = params;
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
    body: JSON.stringify(payload),
  };
  return await fetch(`${API_AUTH_URL}/v1/gauth2fa-verify-totp?token=${token}&userId=${userId}&ipAddress=${ipAddress}&regenerateToken=true`, requestOptions)
}

export async function getResetPasswordOTP(email) {
 
  return await fetch(`${API_AUTH_URL}/v1/user/totp?email=${email}`, {
    method: 'POST',
  })
}

export async function resetPassword(payload) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json'},
    body: JSON.stringify(payload),
  };
  return await fetch(`${API_AUTH_URL}/v1/user/password/reset`, requestOptions)
}